<template>
  <ContentWrap>
    <el-form inline>
      <el-form-item label="酒店">
        <el-select v-model="shopId" clearable filterable class="!w-240px" placeholder="请选择酒店">
          <el-option v-for="item in hotels" :key="item.id" :label="item.name" :value="item.id" />
        </el-select>
      </el-form-item>
      <el-button type="primary" @click="load"
        ><Icon icon="ep:search" class="mr-5px" />查询</el-button
      >
    </el-form>
  </ContentWrap>
  <ContentWrap>
    <el-alert
      v-if="rows.length === 0 && !loading"
      class="mb-16px"
      type="info"
      :closable="false"
      title="暂无已配置租期规则，请由酒店经营台配置后再查看。"
    />
    <el-table v-loading="loading" :data="rows">
      <el-table-column prop="shop_id" label="酒店 ID" width="110" />
      <el-table-column prop="rental_type" label="租赁类型" min-width="120" />
      <el-table-column prop="min_duration" label="起租时长" width="100" />
      <el-table-column prop="unit" label="单位" width="90" />
      <el-table-column prop="discount_rate" label="折扣率" width="100" />
      <el-table-column label="启用" width="80"
        ><template #default="{ row }">{{ row.enabled ? '是' : '否' }}</template></el-table-column
      >
      <el-table-column prop="update_time" label="更新时间" width="180" />
    </el-table>
  </ContentWrap>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { getAllHotelShopSimpleList, type HotelPlatformShopOption } from '@/api/hotel/platformShop'
import { getPlatformRentPolicies } from '@/api/hotel/management'

defineOptions({ name: 'HotelPlatformRentPolicy' })

const loading = ref(false)
const rows = ref<any[]>([])
const hotels = ref<HotelPlatformShopOption[]>([])
const shopId = ref<string | number>()

async function load() {
  loading.value = true
  try {
    rows.value = (await getPlatformRentPolicies({ shopId: shopId.value })) || []
  } finally {
    loading.value = false
  }
}

onMounted(async () => {
  hotels.value = (await getAllHotelShopSimpleList()) || []
  await load()
})
</script>
